import Link from "next/link";
import { Button } from "@/components/ui/button";
import { EmptyCartIcon } from "../icons/assets";

export default function AddToCartEmptyState() {

  return (
    <section className="bg-background pt-30 md:pt-[190px] px-4 sm:px-6 lg:px-10">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="w-full flex flex-col items-center gap-12 sm:gap-16 md:gap-20 lg:gap-24 xl:gap-24">

          {/* SVG */}
          <EmptyCartIcon className="h-auto" />

          {/* Content */}
          <div className="flex flex-col items-center gap-8 sm:gap-10 md:gap-14 lg:gap-16 xl:gap-24 w-full xl:w-[1360px]">

            {/* Heading + Description */}
            <div className="flex flex-col items-center gap-4 sm:gap-5 xl:gap-6 w-full xl:w-[1360px] xl:h-[129px]">
              <h1 className="font-oswald font-medium text-[28px] sm:text-[36px] md:text-[42px] lg:text-[50px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500 text-center xl:h-[80px]">
                Your Cart is Currently Empty
              </h1>
              <p className="font-roboto font-normal text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300 text-center max-w-[90%] md:max-w-[70%] lg:max-w-[60%] xl:max-w-none xl:h-[25px]">
                You haven't added any products yet. Browse our collection to find the right Guniwheel™ for your vehicle.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-3 xl:gap-[12px] w-full sm:w-auto">
              <Button
                asChild
                className="w-full sm:w-auto xl:w-[194px] h-[52px] sm:h-[56px] xl:h-[60px] px-5 py-[10px] rounded-[12px] bg-primary-500 font-oswald font-medium text-[16px] sm:text-[17px] xl:text-[18px] leading-[100%] tracking-[0.2px] uppercase text-white shadow-none cursor-pointer"
              >
                <Link href="/products">View Our Products</Link>
              </Button>

              <Button
                asChild
                className="w-full sm:w-auto xl:w-[140px] h-[52px] sm:h-[56px] xl:h-[60px] px-5 py-[10px] rounded-[12px] bg-neutral-500 font-oswald font-medium text-[16px] sm:text-[17px] xl:text-[18px] leading-[100%] tracking-[0.2px] uppercase text-white shadow-none cursor-pointer"
              >
                <Link href="/fitment">Fit Your Car</Link>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}